import Buttons from '@klv/molecules/buttons';

import * as s from './styles';
import type { ICtaContent } from './types';

const ContentCta = ({ buttons, headline }: ICtaContent) => (
  <s.Wrapper>
  {headline && (
    <s.Message forwardedAs="h1">
      {headline}
    </s.Message>
  )}
  {buttons && (
    <s.CTAWrapper>
     <Buttons
        buttonColor="light"
        variants={['ghost']}
        buttons={buttons}
      />
    </s.CTAWrapper>)
  }
  </s.Wrapper>
);

export default ContentCta;
